import cn from 'classnames';
import { Icon } from '../../Icon';

interface InputErrorMessageProps {
  message: string;
  id?: string;
  /** Renders the alert icon before the message. Off by default so existing error text is unchanged. */
  showIcon?: boolean;
  className?: string;
  textClassName?: string;
}

export const InputErrorMessage = ({
  message,
  id,
  showIcon = false,
  className,
  textClassName = 'text-body-400',
}: InputErrorMessageProps) => (
  <div id={id} role='alert' className={cn('flex items-center gap-1 text-error', className)}>
    {showIcon && <Icon name='errorCircle' size={16} />}
    <p className={cn('mb-0', textClassName)}>{message}</p>
  </div>
);
